import { useSearchParams } from 'next/navigation'
import React from 'react'

import { useAnalyticsParams } from '@/hooks/useAnalytics'

export const useLineAuthUrl = (intended = '/facilities') => {
  const searchParams = useSearchParams()
  const analyticsParams = useAnalyticsParams()
  const referralSubjectCode = searchParams?.get('referral_subject_code') ?? ''
  const campaignCode = searchParams?.get('campaign_code') ?? ''

  const params = React.useMemo(
    () =>
      JSON.stringify({
        referralSubjectCode,
        campaignCode,
        analyticsParams,
        ...(intended ? { intended } : {}),
      }),
    [analyticsParams, campaignCode, referralSubjectCode, intended],
  )

  return `${
    process.env.NEXT_PUBLIC_API_HOST
  }/user/line_oa_begin?params=${encodeURIComponent(params)}`
}
